<template>
  <div class="home">
    <vxe-table border show-header-overflow :align="allAlign" header-align="center" size="mini"
      :row-config="{ isHover: true }" :data="funcData" :scroll-y="{ enabled: true }">
      <vxe-column field="showNumber" title="排查顺序" width="50"></vxe-column>
      <vxe-column field="name" title="排查方法"></vxe-column>
      <vxe-column field="remark" title="根因" width="100"></vxe-column>
      <vxe-column field="id" title="操作" width="55">
        <template #default="{ row }">
          <div @click="intoPage(row)"><van-icon name="arrow" /></div>
        </template>
      </vxe-column>
    </vxe-table>
    <!-- <van-row>
          <van-col span="2" style="text-align:right;font-size: 7px;">编号</van-col>
          <van-col span="12" style="text-align:center;font-size: 7px;">方法</van-col>
          <van-col span="6" style="text-align:center;font-size: 7px;">根因</van-col>
          <van-col span="4" style="text-align:center;font-size: 7px;"></van-col>
          
        </van-row>
    <van-steps direction="vertical" :active="-1" inactive-icon="arrow-down">
      <van-step v-for="item,index in funcData" ::key="index">
        <van-row>
          <van-col span="2" style="text-align:left;font-size: 7px;border-left: 1px solid red;padding: 0px;">{{item.showNumber}}</van-col>
          <van-col span="12" style="text-align:left;font-size: 7px;border-left: 1px solid red;padding: 0px;">{{ item.name}}</van-col>
          <van-col span="6" style="text-align:left;font-size: 7px;">{{ item.remark}}</van-col>
          <van-col span="4" style="text-align:right;font-size: 7px;" @click="intoPage(item)"><van-icon name="arrow" /></van-col>          
        </van-row>

      </van-step>
    </van-steps> -->
  </div>
</template>
<script>
import axios from "axios";
import { Toast } from "vant";
export default {
  data() {
    return {
      funcData: [],
      allAlign: null,
      tableData: [
        {
          id: 10001,
          name: "Test1",
          role: "Develop",
          sex: "Man",
          age: ">",
          address: "test abc",
        },
        {
          id: 10002,
          name: "Test2",
          role: "Test",
          sex: "Women",
          age: ">",
          address: "Guangzhou",
        },
        {
          id: 10003,
          name: "Test3",
          role: "PM",
          sex: "Man",
          age: ">",
          address: "Shanghai",
        },
        {
          id: 10004,
          name: "Test4",
          role: "Designer",
          sex: "Women",
          age: ">",
          address: "Shanghai",
        },
      ],
    };
  },
  created() {
    axios
      .request({
        url:
          "/mgnt/gz/api/request/listfunctions/" +
          window.sessionStorage.getItem("question"),
        method: "post",
      })
      .then((res) => {
        console.log(res.data.data, "=====================");
        if (res.data.code == 0) {
          res.data.data.map((item) => {
            item.remark = item.remark.substr(0, item.remark.length - 1);
          });
          this.funcData = res.data.data;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    intoPage(item) {
      console.log(item);
      if (item.remark == "--") {
        Toast("没有对应方法");
      } else {
        this.$router.push({ path: "/list", query: item });
      }
    },
  },
};
</script>
<style>
.vxe-table--render-default {
  font-size: 10px;
}

.vxe-table--render-default.size--mini {
  font-size: 10px;
}

.vxe-header--column.col--ellipsis>.vxe-cell .vxe-cell--title {
  white-space: normal;
}

.vxe-table--render-default .vxe-body--column,
.vxe-table--render-default .vxe-footer--column,
.vxe-table--render-default .vxe-header--column {
  line-height: normal;
}
</style>